// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7965b805","239":"e39fb35b","453":"03346f77"}[chunkId] + ".chunk.js";
};